module.exports = __webpack_public_path__ + "img/happinessclub.16e3df43.webp";